/** Anzeigenamen für Agent-Tools (kanonisch + deutsche Aliase). */
export const AGENT_TOOL_LABELS = {
  ask_user: 'Rückfrage',
  nachfragen: 'Rückfrage',
  frage: 'Rückfrage',
  list_files: 'Dateien listen',
  dateien_listen: 'Dateien listen',
  search_files: 'Dateien suchen',
  dateien_suchen: 'Dateien suchen',
  grep: 'Dateien suchen',
  read_file: 'Datei lesen',
  datei_lesen: 'Datei lesen',
  write_file: 'Datei schreiben',
  datei_schreiben: 'Datei schreiben',
  edit_file: 'Datei ändern',
  datei_aendern: 'Datei ändern',
  datei_ändern: 'Datei ändern',
  search_replace: 'Datei ändern',
  ersetzen: 'Datei ändern',
  patch: 'Datei ändern',
  mkdir: 'Ordner erstellen',
  ordner_erstellen: 'Ordner erstellen',
  delete_path: 'Löschen',
  datei_loeschen: 'Löschen',
  datei_löschen: 'Löschen',
  ordner_loeschen: 'Löschen',
  ordner_löschen: 'Löschen',
  delete_file: 'Löschen',
  delete_folder: 'Löschen',
  run_check: 'Projekt prüfen',
  pruefen: 'Projekt prüfen',
  start_preview: 'Live starten',
  live_starten: 'Live starten',
  scaffold: 'Vite/React scaffolden',
  projekt_anlegen: 'Vite/React scaffolden',
  npm_scaffold: 'Vite/React scaffolden',
  vite_anlegen: 'Vite/React scaffolden',
  create_vite: 'Vite/React scaffolden',
  create_project: 'Neues Projekt',
  projekt_neu: 'Neues Projekt',
  neues_projekt: 'Neues Projekt',
  projekt_erstellen: 'Neues Projekt',
  list_projects: 'Projekte listen',
  projekte_listen: 'Projekte listen',
  switch_project: 'Projekt wechseln',
  projekt_wechseln: 'Projekt wechseln',
  projekt_aktivieren: 'Projekt wechseln',
  rename_project: 'Projekt umbenennen',
  projekt_umbenennen: 'Projekt umbenennen',
  delete_project: 'Projekt löschen',
  projekt_loeschen: 'Projekt löschen',
  projekt_löschen: 'Projekt löschen',
  move_path: 'Datei verschieben',
  datei_verschieben: 'Datei verschieben',
  stop_preview: 'Live stoppen',
  live_stoppen: 'Live stoppen',
  vorschau_stoppen: 'Live stoppen',
  web_search: 'Websuche',
  websuche: 'Websuche',
  fetch_url: 'Seite laden',
  seite_laden: 'Seite laden',
  generate_image: 'Bild erzeugen',
  bild_erzeugen: 'Bild erzeugen',
  generate_video: 'Video erzeugen',
  video_erzeugen: 'Video erzeugen',
  film_erzeugen: 'Video erzeugen',
  clip_erzeugen: 'Video erzeugen',
  video: 'Video erzeugen',
  generate_sound: 'Sound erzeugen',
  ton_erzeugen: 'Sound erzeugen',
  sound_erzeugen: 'Sound erzeugen',
  audio_erzeugen: 'Sound erzeugen',
  sound: 'Sound erzeugen',
  audio: 'Sound erzeugen',
  tts: 'Sound erzeugen',
  generate_pdf: 'PDF erzeugen',
  pdf_erzeugen: 'PDF erzeugen',
  dokument_erzeugen: 'PDF erzeugen',
  pdf: 'PDF erzeugen',
  search_ui_components: 'UI-Komponenten suchen',
  search_component: 'UI-Komponenten suchen',
  ui_suchen: 'UI-Komponenten suchen',
  komponenten_suchen: 'UI-Komponenten suchen',
  get_component_code: 'Komponenten-Code laden',
  get_component: 'Komponenten-Code laden',
  komponenten_code: 'Komponenten-Code laden',
  install_component: 'Komponente installieren',
  komponente_installieren: 'Komponente installieren',
  preview_component: 'Komponente ansehen',
  komponente_vorschau: 'Komponente ansehen',
  analyze_design_system: 'Designsystem analysieren',
  designsystem_analysieren: 'Designsystem analysieren',
  find_animation: 'Animation auswählen',
  animation_finden: 'Animation auswählen',
  find_icon: 'Icon suchen',
  icon_finden: 'Icon suchen',
  find_3d_component: '3D-Komponente suchen',
  '3d_komponente_finden': '3D-Komponente suchen',
  final: 'Fertig',
  fertig: 'Fertig',
};

export function agentToolLabel(tool, fallbackLabel = '') {
  if (fallbackLabel) return fallbackLabel;
  const key = String(tool || '')
    .trim()
    .toLowerCase();
  return AGENT_TOOL_LABELS[key] || tool || 'Schritt';
}
